module.exports = __webpack_public_path__ + "img/panelView_baoSteel_2_1_.edfcb5f1.png";